import { FieldHasValue, ValidateNumberField } from 'helpers/Validation';

export const AsLeftResultFormula = (formData) => {
    if (
        FieldHasValue(formData.F652asLeftTripPoint)
        && FieldHasValue(formData.F1056AltObservedTripSetpoint)
        && FieldHasValue(formData.F185AltHmireading)
        && FieldHasValue(formData.F101AftTolerance)) {
        if (ValidateNumberField(formData.F186AltDeviation)
            <= ValidateNumberField(formData.F101AftTolerance) && (formData.F185AltHmireading === 'Equipment Tripped')) {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
